module.exports = __webpack_public_path__ + "static/img/item3.74b140c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/item3.png
// module id = YlaW
// module chunks = 63